export class SearchPricingRequest {
  channel: string | undefined;
  regionId: string | undefined;
  productIds: Array<number> = [];
  lockTerm: number | undefined;
  dateRange: Array<Date> = [];
  useLatest: boolean = true;
  take?: number;
}
